export const EDIT_USER = 'EDIT_USER';
export const SET_USER = 'SET_USER';
export const RESET_USER = 'RESET_USER';
export const REDUCE_STORAGE_USER = 'REDUCE_STORAGE_USER';
export const INCREASE_STORAGE_USER = 'INCREASE_STORAGE_USER';

export function editUser(value) {
  return {
    type: EDIT_USER,
    value,
  };
}

export function setUser(value) {
  return {
    type: SET_USER,
    value,
  };
}

export function reduceStorageUser(value) {
  return {
    type: REDUCE_STORAGE_USER,
    value,
  };
}

export function increaseStorageUser(value) {
  return {
    type: INCREASE_STORAGE_USER,
    value,
  };
}

export function resetUser() {
  return {
    type: RESET_USER,
  };
}
